<template>
  <div class="bottom-navigator-wrapper" :class="{ hidden: isHidden }">
    <!-- Center Golden Button -->
    <div class="center-button" @click="handleCenterButtonClick">
      <div class="center-icon">
        <lottie-icon
          ref="centerLottie"
          :src="centerLottieConfig.src"
          :size="centerLottieConfig.size"
          :autoplay="centerLottieConfig.autoplay"
          :loop="centerLottieConfig.loop"
        />
      </div>
    </div>

    <!-- Navigation Bar -->
    <nav class="bottom-navigator">
      <!-- Item 1: Home -->
      <div
        class="nav-item"
        @click="
          $emit(
            'nav-item-click',
            { icon: 'HomeIcon', label: 'หน้าหลัก', route: '/dashboard' },
            0
          )
        "
      >
        <div class="nav-icon-wrapper">
          <svg
            class="nav-icon-img dashboard-icon"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Dashboard"
          >
            <path
              d="M21,7V4a1,1,0,0,0-1-1H15a1,1,0,0,0-1,1V7a1,1,0,0,0,1,1h5A1,1,0,0,0,21,7ZM10,20V17a1,1,0,0,0-1-1H4a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1H9A1,1,0,0,0,10,20Z"
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.344"
            />
            <path
              d="M9,12H4a1,1,0,0,1-1-1V4A1,1,0,0,1,4,3H9a1,1,0,0,1,1,1v7A1,1,0,0,1,9,12Zm12,8V13a1,1,0,0,0-1-1H15a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1h5A1,1,0,0,0,21,20Z"
              fill="none"
              stroke="#ffffff"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.344"
            />
          </svg>
        </div>
        <div class="nav-label">
          หน้าหลัก
        </div>
      </div>

      <!-- Item 2: Activities -->
      <div
        class="nav-item"
        @click="
          $emit(
            'nav-item-click',
            { icon: 'CalendarIcon', label: 'ฝาก', route: '/deposit' },
            1
          )
        "
      >
        <div class="nav-icon-wrapper">
          <svg
            class="nav-icon-img deposit-icon"
            viewBox="0 0 1024 1024"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Deposit"
          >
            <path
              d="M467.2 332.8l230.4-83.2 44.8 83.2zM384 332.8l96-83.2 38.4 51.2-64 32z"
              fill="#ffffff"
            />
            <path
              d="M300.8 755.2c-25.6 0-51.2-25.6-51.2-51.2V384c0-25.6 25.6-51.2 51.2-51.2h428.8c25.6 0 51.2 25.6 51.2 51.2v313.6c0 25.6-25.6 51.2-51.2 51.2l-428.8 6.4z"
              fill="currentColor"
            />
            <path
              d="M761.6 608H704c-25.6 0-51.2-19.2-51.2-51.2v-19.2c0-25.6 25.6-51.2 51.2-51.2h57.6c25.6 0 51.2 19.2 51.2 51.2v25.6c0 25.6-19.2 44.8-51.2 44.8z"
              fill="#ffffff"
            />
          </svg>
        </div>
        <div class="nav-label">
          ฝาก
        </div>
      </div>

      <!-- Spacer for center button -->
      <div class="nav-spacer">
        <div class="center-text">
          เข้าเล่น
        </div>
      </div>

      <!-- Item 4: Promotions -->
      <div
        class="nav-item"
        @click="
          $emit(
            'nav-item-click',
            { icon: 'SettingsIcon', label: 'ถอน', route: '/withdraw' },
            3
          )
        "
      >
        <div class="nav-icon-wrapper">
          <img
            src="@/assets/icons/withdraw.svg"
            class="nav-icon-img"
            alt="Withdraw"
          />
        </div>
        <div class="nav-label">
          ถอน
        </div>
      </div>

      <!-- Item 5: Notifications -->
      <div
        class="nav-item"
        @click="
          $emit(
            'nav-item-click',
            { icon: 'BellIcon', label: 'คืนยอด', route: '/cashback' },
            4
          )
        "
      >
        <div class="nav-icon-wrapper">
          <img
            src="@/assets/icons/cashback.svg"
            class="nav-icon-img"
            alt="Cashback"
          />
        </div>
        <div class="nav-label">
          คืนยอด
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import LottieIcon from '@/@core/components/lottie-icon/LottieIcon.vue'

export default {
  name: 'WitcherBottomNavigator',
  components: {
    LottieIcon
  },
  props: {
    isHidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    centerLottieConfig() {
      const defaults = {
        src: 'assets/lottie/coin.json',
        size: 160,
        autoplay: true,
        loop: true
      }
      return { ...defaults, ...(this.$theme && this.$theme.centerLottie) }
    }
  },
  methods: {
    handleCenterButtonClick() {
      if (this.$route.path === '/') {
        // On homepage - emit event to reset homepage state
        this.$emit('navigate-home')
      } else {
        // Not on homepage - navigate to home route
        this.$router.push('/')
      }
    }
  },
  emits: ['nav-item-click', 'navigate-home']
}
</script>

<style lang="scss" scoped>
// Fixed dark theme colors
$bg-base: #0a0a0a;
$bg-card: #1a1a2e;
$bg-elevated: #16213e;
$bg-deep: #0d0816;

.bottom-navigator-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
  transition: transform 0.8s cubic-bezier(0.25, 0.8, 0.25, 1);

  &.hidden {
    transform: translateY(100%);
  }
}

// Center Button (uses theme secondary color)
.center-button {
  position: absolute;
  bottom: 42px; // Positioned to float above the nav bar
  left: 50%;
  transform: translateX(-50%);
  width: 70px;
  height: 70px;
  background: rgba(var(--theme-secondary-rgb), 0.25);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  pointer-events: auto;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1001;

  .center-icon {
    color: #000;
    pointer-events: none;
  }

  .center-label {
    color: #000;
    font-size: 9px;
    font-weight: 600;
    text-align: center;
    line-height: 1.1;
  }
}

// Navigation Bar
.bottom-navigator {
  position: relative;
  width: 100%;
  height: 70px;
  background: var(--theme-nav-bg) !important;
  border-top: 1px solid rgba(var(--theme-secondary-rgb), 0.4);
  position: relative;

  display: flex;
  align-items: center;
  margin: 0;

  // Use CSS mask to create the semicircular cutout
  -webkit-mask: radial-gradient(
    circle 40px at 50% 0px,
    transparent 39px,
    black 40px
  );
  mask: radial-gradient(circle 30px at 50% 0px, transparent 36px, black 37px);
}

.nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 5px 3px;
  transition: all 0.3s ease;
  border-radius: 12px;

  &:hover {
    transform: translateY(-2px);
    background: rgba(var(--theme-secondary-rgb), 0.15);

    .nav-icon,
    .nav-label {
      color: var(--theme-secondary-light);
    }
  }

  .nav-icon {
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 4px;
    transition: color 0.3s ease;
  }

  .nav-icon-wrapper {
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 2px;
  }

  .nav-icon-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    transition: transform 0.3s ease;
  }

  .dashboard-icon,
  .deposit-icon {
    color: var(--theme-primary);
  }

  &:hover .nav-icon-img {
    transform: scale(1.1);
  }

  .nav-label {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
    text-align: center;
    font-weight: 300;
    white-space: nowrap;
    transition: color 0.3s ease;
  }
}

.nav-spacer {
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;

  .center-text {
    color: rgba(255, 255, 255, 0.8);
    text-align: center;
    font-weight: 300;
    white-space: nowrap;
    position: absolute;
    bottom: -28px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
  }
}

// Responsive adjustments
@media (max-width: 480px) {
  .center-button {
    width: 65px;
    height: 65px;
    bottom: 42px;

    .center-label {
      font-size: 8px;
    }
  }

  .nav-item {
    padding: 8px 3px;

    .nav-label {
      font-size: 14px;
    }
  }
}
</style>
